"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillCampaignToJSON = exports.BillCampaignFromJSONTyped = exports.BillCampaignFromJSON = exports.instanceOfBillCampaign = void 0;
var runtime_1 = require("../runtime");
var BillAdSet_1 = require("./BillAdSet");
/**
 * Check if a given object implements the BillCampaign interface.
 */
function instanceOfBillCampaign(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfBillCampaign = instanceOfBillCampaign;
function BillCampaignFromJSON(json) {
    return BillCampaignFromJSONTyped(json, false);
}
exports.BillCampaignFromJSON = BillCampaignFromJSON;
function BillCampaignFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'adSets': !(0, runtime_1.exists)(json, 'ad_sets') ? undefined : (json['ad_sets'].map(BillAdSet_1.BillAdSetFromJSON)),
    };
}
exports.BillCampaignFromJSONTyped = BillCampaignFromJSONTyped;
function BillCampaignToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'ad_sets': value.adSets === undefined ? undefined : (value.adSets.map(BillAdSet_1.BillAdSetToJSON)),
    };
}
exports.BillCampaignToJSON = BillCampaignToJSON;
